import { useEffect } from 'react'
import { getStatusBarHeight, canIUse } from '@bcz/fe-interface'
import { delay } from '@/utils'
import { useSupportHairline } from '@/hooks'

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 */
export function InjectCssVars({ children }) {
  const { supportHairline } = useSupportHairline()

  useEffect(() => {
    const hairlineSizeKey = '--hairline-size'
    document.body.style.setProperty(hairlineSizeKey, `${supportHairline ? 0.5 : 1}px`)

    return () => {
      document.body.style.removeProperty(hairlineSizeKey)
    }
  }, [supportHairline])

  useEffect(() => {
    const statusBarHeightKey = '--status-bar-height'

    ;(async () => {
      await delay(400)

      const testElem = document.createElement('div')
      testElem.classList.add('nib-safe-area', 'nib-safe-area-position-top')

      if (canIUse('getStatusBarHeight')) {
        testElem.style.paddingTop = `${getStatusBarHeight()}px`
      }

      document.body.appendChild(testElem)
      const height = testElem.offsetHeight
      document.body.removeChild(testElem)

      document.body.style.setProperty(statusBarHeightKey, `${height}px`)
    })()
  }, [])

  return <>{children}</>
}
